import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import './styles.scss';

export const SnowSkiPopup = memo(function SnowSkiPopup({resortName, street, city, state, zip, numLifts, liftsOpenWeekend, liftsOpen, surfaceTop}) {
    return (
        <SnowSkiContainer>
            <SnowSkiHeader>
                {resortName}
            </SnowSkiHeader>
            {street}<br />
            {city}, {state}&nbsp;{zip}<br />
            {numLifts && (<span>Total Lifts: {numLifts}<br /></span>)}
            {liftsOpen && <span>Open Lifts: {liftsOpen}<br /></span>}
            {liftsOpenWeekend && <span>Lifts Weekend: {liftsOpenWeekend}<br /></span>}
            {surfaceTop && <span>Snow Condition: {surfaceTop}<br /></span>}
        </SnowSkiContainer>
    );
});

SnowSkiPopup.propTypes = {
    resortName: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
    numLifts: PropTypes.number,
    liftsOpenWeekend: PropTypes.bool,
    liftsOpen: PropTypes.number,
    surfaceTop: PropTypes.string
};

const SnowSkiContainer = styled.div`
    background-color: #0083C6;
    color: #FFFFFF;
    border-radius: 3px;
    padding: 15px 10px 15px;
    margin: 0;
    text-align: left;
    font: 12px/20px 'Helvetica Neue',
    rial,Helvetica,sans-serif;
`;

const SnowSkiHeader = styled.span`
    font-weight: bold;
    display: block;
`;